import React, { Component } from 'react';
import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';

class Directions extends Component {
    render() {
        return (
            <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1.5}>
                <FullWrapper caseName="directions" isMargin={false} smallPaddings={true}>
                    <div className="directions__grid">
                        <div className="directions__item directions__item--left">
                            <div className="directions__top">
                                <CommonTitle>Направления</CommonTitle>
                                <ScrollAnimation
                                    animateIn="fadeIn"
                                    offset={50}
                                    delay={200}
                                    animateOnce={true}
                                    duration={1}
                                >
                                    <CommonUsualText className="directions__text-info">
                                        Три направления работы по продвижению сообщества
                                    </CommonUsualText>
                                </ScrollAnimation>
                            </div>
                            <div className="directions__bot">
                                <ScrollAnimation
                                    animateIn="fadeIn"
                                    offset={50}
                                    delay={300}
                                    animateOnce={true}
                                    duration={1}
                                >
                                    <div className="directions-bg">
                                        <div className="directions-bg__text">
                                            По каждому направлению наша команда отрабатывала
                                            гипотезы, чтобы найти самую удачную
                                        </div>
                                    </div>
                                </ScrollAnimation>
                            </div>
                        </div>
                        <div className="directions__item directions__item--right">
                            <div className="directions-blocks">
                                <ScrollAnimation
                                    animateIn="fadeInUp"
                                    offset={50}
                                    delay={200}
                                    animateOnce={true}
                                    duration={1}
                                    className="directions-blocks__row"
                                >
                                    <div className="directions-blocks__title">
                                        <div className="directions-blocks__icon">
                                            <img
                                                src="/images/png/accelerator.png"
                                                alt="Акселератор"
                                                loading="lazy"
                                            />
                                        </div>
                                        <div className="directions-blocks__name">Акселератор</div>
                                    </div>
                                    <div className="directions-blocks__desc">
                                        Работа с молодыми стартапами на уровне акселерации, набор в
                                        онлайн-акселератор.
                                    </div>
                                </ScrollAnimation>

                                <ScrollAnimation
                                    animateIn="fadeInUp"
                                    offset={50}
                                    delay={200}
                                    animateOnce={true}
                                    duration={1}
                                    className="directions-blocks__row"
                                >
                                    <div className="directions-blocks__title">
                                        <div className="directions-blocks__icon">
                                            <img
                                                src="/images/png/start-up.png"
                                                alt="Стартапы"
                                                loading="lazy"
                                            />
                                        </div>
                                        <div className="directions-blocks__name">Стартапы</div>
                                    </div>
                                    <div className="directions-blocks__desc">
                                        Принятие стартапов на уровне pre-seed, seed в воронку, в
                                        которую есть доступ у инвесторов. В дальнейшем инвесторы
                                        могут выбрать стартапы из воронки для организации демодня.
                                    </div>
                                </ScrollAnimation>

                                <ScrollAnimation
                                    animateIn="fadeInUp"
                                    offset={50}
                                    delay={200}
                                    animateOnce={true}
                                    duration={1}
                                    className="directions-blocks__row"
                                >
                                    <div className="directions-blocks__title">
                                        <div className="directions-blocks__icon">
                                            <img
                                                src="/images/png/case.png"
                                                alt="Инвесторы"
                                                loading="lazy"
                                            />
                                        </div>
                                        <div className="directions-blocks__name">Инвесторы</div>
                                    </div>
                                    <div className="directions-blocks__desc">
                                        Сообщество инвесторов, для которых Adventureland готов
                                        подобрать инвестиционные проекты и дать экспертизу
                                        начинающим инвесторам.
                                    </div>
                                </ScrollAnimation>
                            </div>
                        </div>
                    </div>
                </FullWrapper>
            </ScrollAnimation>
        );
    }
}

export default Directions;
